import { i18n } from './../constants/I18N';
import { EventEmitter, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { EmployeeInfo, IsLoadingParams, ScreenData, SystemInfo } from './model-generated/models';
import { ScreenPOJO } from './model-generated/web-base';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { lookup } from 'src/constants/Lookup';
import { Router } from '@angular/router';
import { ErrorService } from './components/common/error/error.service';


@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor(
    public cookieService: CookieService,
    public titleService: Title,
    public http: HttpClient,
    public router: Router,
    public errorService: ErrorService
  ) { }

  public isAuth: BehaviorSubject<boolean> = new BehaviorSubject(null);
  public isLoginPopupOpen: boolean;
  public employeeInfo: EmployeeInfo;
  public fullScreenMode: boolean = false;
  public isLoading: BehaviorSubject<IsLoadingParams> = new BehaviorSubject(null);
  public isSystemInfoOpen: boolean;
  public systemInfo: BehaviorSubject<SystemInfo> = new BehaviorSubject(null);
  public currentScreen: BehaviorSubject<ScreenData> = new BehaviorSubject({ name: "", value: "BASE" } as ScreenData);
  public needToRefreshViewData: boolean;
  public contrastMode: boolean = false;

  public isSelectOwnersPopupOpen: boolean;
  public isSelectWhsesPopupOpen: boolean;
  public isChangePasswordPopupOpen: boolean;

  public focusIsOnSearch: boolean;

  public isAiChatOpen: boolean;

  /**
   * Текущие выбранные ID строк на активном экране.
   * Обновляется компонентами FlexView при изменении выделения.
   */
  public selectedIds$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

  /**
   * Имя активного поля формы на текущем экране (для CRUD).
   * Обновляется при фокусе на полях ввода.
   */
  public activePropertyName$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  public isLoadingUpdated: EventEmitter<boolean> = new EventEmitter();

  async setAuth(isAuth: boolean, jwt?: string, employeeInfo?: EmployeeInfo): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      this.isAuth.next(isAuth);

      try {
        if (isAuth) {
          this.cookieService.set("token", jwt);
          // this.cookieService.set("JSESSIONID", null, 200000, "/", "test4");
          this.employeeInfo = employeeInfo;

          this.currentScreen.next({ name: null, value: "BASE" });
          await this.loadSystemInfo();
        } else {
          this.cookieService.delete("token");
          // this.cookieService.delete("JSESSIONID", "/");
          // this.cookieService.deleteAll();
          this.employeeInfo = null;

          this.currentScreen.next({ name: "LOGIN", value: "LOGIN" });
          this.systemInfo.next(null);
        }
        resolve();
      } catch(error) {
        reject(error);
      } finally {
        this.setIsLoading(false);
      }
    })
  }

  public hasRole(role: string) {
    return this.employeeInfo?.roles?.indexOf(role) >= 0;
}

  setSystemInfoPopup(value?: boolean) {
    if (value) {
      this.isSystemInfoOpen = value
    } else {
      this.isSystemInfoOpen = !this.isSystemInfoOpen
    }
  }

  setChangePasswordPopup(value?: boolean) {
    if (value) {
      this.isChangePasswordPopupOpen = value
    } else {
      this.isChangePasswordPopupOpen = !this.isChangePasswordPopupOpen
    }
  }

  setIsLoading(value: boolean, params?: { mode?: "ALL_SCREEN" | "SCREEN_INSTANCE", showAnimation?: boolean }) {
    this.isLoading.next({
      value: value,
      mode: params?.mode ?? 'ALL_SCREEN',
      showAnimation: params?.showAnimation ?? false
    });
  }

  getCurrentScreen(): Observable<ScreenData> {
    return this.currentScreen;
  }

  async loadSystemInfo() {
    return new Promise<void>((resolve, reject) => {
      this.http.get<SystemInfo>(environment.apiCrudUrl + "/systeminfo")
        .subscribe({
          next: async (res) => {
            // if (this.cookieService.get("dbVersion") != res.dbVersion) {
            //   // localStorage.clear();
            //   await lookup.update();
            //   await i18n.update();
            //   this.cookieService.set("dbVersion", res.dbVersion);
            // }
            this.systemInfo.next(res);
            resolve();
          },
          error: (error) => reject()
        })
    })
  }

  getSystemInfo(): Observable<SystemInfo> {
    return this.systemInfo;
  }

  setAppTitle() {
    let name;
    let userLogin;

    let setTitle = () => {
      let title = "InStock WMS";

      if (name) {
        title += ` - ${i18n.tr(name)}`;
      }

      if (userLogin) {
        title += ` - ${userLogin}`;
      }

      this.titleService.setTitle(title);
    }

    this.getCurrentScreen()
      .subscribe(res => {
        name = res?.name;
        setTitle();
      })

    this.getSystemInfo()
      .subscribe(res => {
        userLogin = res?.userLogin;
        setTitle();
      })
  }

  setFocusIsOnSearch(focusIsOnSearch: boolean) {
    this.focusIsOnSearch = focusIsOnSearch;
  }

  setAiChat(value: boolean) {
    this.isAiChatOpen = value;
  }

  public setContrastMode() {
    this.contrastMode = !this.contrastMode;
    localStorage.setItem("contrastMode", this.contrastMode.toString());
  }

  public async logout() {
    this.setIsLoading(true);

    this.http.post(environment.authUrl + "/logout", null, { responseType: "text" })
      .subscribe({
        next: async (res) => {
          await this.setAuth(false);
          this.router.navigate(["/login"]);
          this.setIsLoading(false);
        },
        error: (error) => this.errorService.showError(error)
      })
  }
}
